const remToPixel = (rem) => {
  const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
  const pixels = rem * rootFontSize;
  return pixels;
};

const createDebouncer = (wait) => (fn) => {
  let i = 0;
  return (...args) => {
    const currentI = ++i;
    wait(() => {
      if (currentI === i) {
        fn(...args);
      }
    });
  };
};

// https://stackoverflow.com/questions/8495687/split-array-into-chunks#comment84212474_8495740
const arrayChunk = (array, chunkSize) => {
  return Array(Math.ceil(array.length / chunkSize))
    .fill()
    .map((_, index) => index * chunkSize)
    .map((begin) => array.slice(begin, begin + chunkSize));
};

const request = async (url, params) => {
  const res = await fetch(url, params);
  if (!res.ok) {
    const responseError = await res.json();
    console.error(`NETWORK RESPONSE ERROR -- ${responseError.status}: `, responseError);
    throw responseError;
  }

  return res.json();
};

const convertToCamelCase = (string) => {
  if (!string) {
    return '';
  }

  return string
    .replace(/.\b(?<word>\w)/g, (_, $1) => {
      return $1.toUpperCase();
    })
    .replace(/[\s:'"]/g, '')
    .replace(/^(?<rest>.)/u, (_, $1) => {
      return $1.toLowerCase();
    });
};

// https://github.com/sindresorhus/p-defer/blob/0abf7f56337a450cbff45074dd8c83f8ace4726c/index.js
const pDefer = () => {
  const deferred = {};

  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });

  return deferred;
};

function formatPrice(currency, price) {
  if (currency) {
    const options = {
      style: 'currency',
      currency: currency,
    };
    return new Intl.NumberFormat('en-US', options).format(parseFloat(price));
  }
  return price;
}

function simplePrice(formattedPrice) {
  if (typeof formattedPrice === 'string') {
    let simplePrice = formattedPrice
    // .replace(/,/g, '');
    if (simplePrice.endsWith('.00')) {
      simplePrice = simplePrice.slice(0, -3);
    }
    return simplePrice;
  }
  return formattedPrice;
}

function createGlobalId(id, type) {
  let stringId = id.toString();
  if (stringId.startsWith('gid://')) {
    return id.toString();
  } else if (!stringId) {
    return null;
  } else {
    return `gid://shopify/${type}/${id}`;
  }
}

function createStandardId(id) {
  let stringId = id.toString();
  if (stringId && stringId.startsWith('gid://shopify/')) {
    const parts = stringId.split('/');
    return parts[parts.length - 1];
  } else {
    return id;
  }
}

function getSavingsPercentage(compareAtPrice, price) {
  const moneyOff = compareAtPrice - price;
  const decimalOff = moneyOff / compareAtPrice;
  const percentage = Math.round(decimalOff * 100);
  return `${percentage}%`;
}

function disableBodyScroll() {
  if (html.classList.contains(disableBodyScrollClass)) return;

  const scrollBarWidth = `${window.innerWidth - document.documentElement.clientWidth}px`;

  html.style.paddingRight = scrollBarWidth;
  html.style.setProperty('--scroll-bar-width', scrollBarWidth);
  html.classList.add(disableBodyScrollClass);
}

function enableBodyScroll() {
  html.classList.remove(disableBodyScrollClass);
  html.style.setProperty('--scroll-bar-width', '');
  html.style.paddingRight = '';
}

function keyBy(array, key) {
  return array.reduce((accumulator, item) => {
    accumulator[item[key]] = item;
    return accumulator;
  }, {});
}

const openDrawers = new Set();
const html = document.documentElement;
const disableBodyScrollClass = 'disable-body-scroll';
